import $ from 'jquery';

$(function() {

    initProductSlider();

});

function initProductSlider() {

    $('.product-slider-controls i').on('click', function() {

        let direction = 'right';
        if ($(this).hasClass('fa-circle-chevron-right')) {
            direction = 'left';
        }

        let $sliderOuter = $(this).closest('.product-slider-outer').first();
        let $tilesWrapper = $sliderOuter.find('.product-tiles-wrapper').first();
        if (!$tilesWrapper) { return; }
        let $tiles = $tilesWrapper.find('.product-tiles').first();
        if (!$tiles) { return; }

        let width = ($($tilesWrapper.find('.product-tile')[1]).offset().left - $($tilesWrapper.find('.product-tile')[0]).offset().left);
        let productTilesLeft = parseFloat($tiles.css('left'));
        let left = 0;

        if (direction === 'left') {
            let productTilesWrapperWidth = $tilesWrapper.width();
            let productTilesWidth = $tiles.width();
            // Check if we have shifted a whole number of tiles
            left = (productTilesLeft - width);
            if (!Number.isInteger(left / width)) {
                left = (Math.ceil(left / width) * width);
            }
            // Set the new left value
            if (productTilesWrapperWidth < (productTilesWidth + productTilesLeft)) {
                $tiles.css('left', left + 'px');
            }
        } else {
            if (productTilesLeft < 0) {
                // Check if we have shifted a whole number of tiles
                left = (productTilesLeft + width);
                if (left > 0) {
                    left = 0;
                }
                // Set the new left value
                $tiles.css('left', left + 'px');
            }

        }

    });

}
